import React, { useState } from "react";

import { passwordStrength } from "check-password-strength";

import { changePassword } from "services";

import { incompleteMessage, setLocalKlimVar, useAppType, useNavigate, useParams, useToggleNavs, useTranslation } from "utils";

import { Col, ErrorBoundary, Form, MainPage, Row, ScreenSplit, Message as message } from "components";

import { PasswordResetButtons } from "pages/app/account/components/PasswordResetButtons";
import { PasswordResetInputs } from "pages/app/account/components/PasswordResetInputs";
import { TestimonialScreen } from "pages/app/account/components/TestimonialScreen";

interface PasswordResetFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export const PasswordReset = () => {
  const { t } = useTranslation(["signinup", "meta"]);
  const appType = useAppType();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  useToggleNavs(false, appType.mobile);

  const complete = (v: PasswordResetFormValues): void => {
    const passwordAnalysis = passwordStrength(v.password);
    if (v.password !== v.confirmPassword) {
      message({ content: t("password.notMatching"), icon: "error" });
    } else if (passwordAnalysis.contains.length < 3 || v.password.length < 6) {
      message({ content: t("profileUpdate.password.weak"), icon: "error" });
    } else {
      setLoading(true);
      const controller = new AbortController();

      changePassword({
        ...v,
        token: token || "",
        signal: controller.signal,
      })
        .then((res) => {
          setLocalKlimVar("token", res.token);
          navigate("/dashboard");
          message({ content: t("changePassword.changed"), icon: "tick" });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <ScreenSplit sideChildren={<TestimonialScreen farmerType="default" />}>
      <MainPage loading={loading} pageName={"sign-in-up"} containerClass={appType.mobile ? "small" : ""}>
        <section className="container">
          <Row justify="space-around" align="middle" className="mini-form">
            <Col>
              <Row>
                <Col className="left">
                  <h2>{t("changePassword.title")}</h2>
                  <p className="margin-top-100 margin-bottom-0">{t("changePassword.resetDescription")}</p>
                </Col>
              </Row>
              <Form
                name="password"
                className="margin-top-400"
                onFinish={(v) => complete(v)}
                onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}
              >
                <ErrorBoundary>
                  <PasswordResetInputs />
                </ErrorBoundary>
                <ErrorBoundary>
                  <PasswordResetButtons loading={loading} />
                </ErrorBoundary>
              </Form>
            </Col>
          </Row>
        </section>
      </MainPage>
    </ScreenSplit>
  );
};
